import React, { useEffect, useState } from "react";
import HistoricoImportacao from "./HistoricoImportacao";
import Upload from "./Upload";
import ModeloPlanilha from './ModeloPlanilha';
import { OrganizadorModal, OrganizadorButton } from "organizador";
import ImportarDadosPisCofins from "./ImportarDadosPisCofins";
import { message } from "antd";
import { importarDadosFromRec, validarDadosFromRec } from './ImportarDadosPisCofins/actions';
import _ from "lodash";

function Document() {
  const [verHistorico, setVerHistorico] = useState(true);
  const [isModalOpen, setModalIsOpen] = useState(false);
  const [visibleModalImportacaoPisCofins, setVisibleModalImportacaoPisCofins] = useState(false);
  const [loadingImportacaoPisCofins, setLoadingImportacaoPisCofins] = useState(false);
  const [permitirImportacaoFromRec, setPermitirImportacaoFromRec] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [permissao, setPermissao] = useState({ cnpj: '', permitir: false });
  const [currentCnpj, setCurrentCnpj] = useState('');

  const tokenJwt = sessionStorage.getItem("eRecuperadorJwt");
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  const razaoSocial = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).RazaoSocial;
  const moduloIcms = !!sessionStorage.getItem("icmsModule");

  const OnCloseModal = () => {
    setModalIsOpen(false);
  };

  const OnConfirmImportacaoPisCofins = async () => {
    setLoadingImportacaoPisCofins(true);
    const result = await importarDadosFromRec(cnpj);
    message.success(result.Mensagem);
    setVerHistorico(false);
    setVerHistorico(true);
    setVisibleModalImportacaoPisCofins(false);
    setLoadingImportacaoPisCofins(false);
  };

  const validarPermissaoImportarDadosFromRec = async () => {
    setVisibleModalImportacaoPisCofins(true);

    if (_.isEmpty(permissao.cnpj) || permissao.cnpj !== cnpj || permissao.cnpj !== currentCnpj) {
      setLoadingData(true);
      const validacao = await validarDadosFromRec(cnpj);
      setPermitirImportacaoFromRec(validacao);
      setPermissao({ cnpj: currentCnpj, permitir: validacao });
      setLoadingData(false);
    }
  };

  useEffect(() => {
    setCurrentCnpj(JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj);
  }, [cnpj, currentCnpj]);

  return (
    <>
      <ModeloPlanilha />

      <Upload setVerHistorico={setVerHistorico} />
      <br />
      <div style={{ display: 'flex' }}>
        <OrganizadorButton onClick={() => setModalIsOpen(!isModalOpen)} />
        {moduloIcms &&
          <ImportarDadosPisCofins
            onClick={() => validarPermissaoImportarDadosFromRec(currentCnpj)}
            cnpj={cnpj}
            razaoSocial={razaoSocial}
            visible={visibleModalImportacaoPisCofins}
            onClose={() => setVisibleModalImportacaoPisCofins(false)}
            onConfirm={OnConfirmImportacaoPisCofins}
            loading={loadingImportacaoPisCofins}
            loadingData={loadingData}
            permitirImportacao={permitirImportacaoFromRec}
          />
        }

      </div>
      {verHistorico && <HistoricoImportacao />}

      <OrganizadorModal
        api={process.env.REACT_APP_ORGANIZADOR_URL_API}
        cnpj={cnpj}
        produto={moduloIcms ? "ERecSegregador" : "ERecPisCofins"}
        token={tokenJwt}
        visible={isModalOpen}
        onClose={OnCloseModal} />
    </>
  );

}

export default Document;